export default {
  message: {
    hello: 'Xin chào, Thế giới!',
    welcome: 'Chào mừng đến với Trang web Đa ngôn ngữ Vue',
    products: 'Danh sách sản phẩm',
    language: 'Ngôn ngữ',
    chinese_simplified: 'Tiếng Trung Giản thể',
    english: 'Tiếng Anh',
    vietnamese: 'Tiếng Việt',
    chinese_traditional: 'Tiếng Trung Phồn thể',
    home: 'Trang chủ',
    about: 'Về chúng tôi',
    contact: 'Liên hệ',
    sitemap: 'Sơ đồ trang',
    description: 'Đây là một ví dụ về trang web Vue có hỗ trợ đa ngôn ngữ',
    sitemapSubtitle: 'Chỉ mục đầy đủ của tất cả các trang trên trang web này để trình thu thập dữ liệu của công cụ tìm kiếm và người dùng duyệt',
    staticPages: 'Trang tĩnh',
    productCategories: 'Danh mục sản phẩm',
    productList: 'Danh sách sản phẩm',
    allCategories: 'Tất cả danh mục',
    searchProducts: 'Tìm kiếm sản phẩm...',
    loadMore: 'Tải thêm',
    xmlSitemap: 'Sơ đồ trang XML',
    xmlSitemapDescription: 'Tệp sơ đồ trang tiêu chuẩn cho công cụ tìm kiếm (sitemap.xml)',
    priority: 'Ưu tiên',
    updateFrequency: 'Tần suất cập nhật',
    productUnit: 'sản phẩm',
    loading: 'Đang tải...',
    retry: 'Thử lại',
    fetchSitemapError: 'Không thể lấy sơ đồ trang, vui lòng thử lại sau',
    daily: 'Hàng ngày',
    weekly: 'Hàng tuần',
    monthly: 'Hàng tháng'
  },
  pagination: {
    previous: 'Trang trước',
    next: 'Trang sau',
    page_info: 'Trang {current} / {total} ({count} bản ghi)'
  },
  product: {
    categories: {
      title: 'Danh mục sản phẩm',
      consumer_mosfet: 'MOSFET tiêu dùng',
      industrial_mosfet: 'MOSFET công nghiệp',
      automotive_mosfet: 'MOSFET ô tô',
      power_module: 'Mô-đun nguồn',
      ovp: 'OVP',
      ldo: 'LDO',
      pmic: 'PMIC'
    },
    search: 'Tìm kiếm sản phẩm...',
    no_results: 'Không tìm thấy sản phẩm phù hợp',
    purchase_button: 'Mua hàng',
    detail: {
      back: 'Quay lại',
      basic_info: 'Thông tin cơ bản',
      technical_params: 'Thông số kỹ thuật',
      documents: 'Tài liệu',
      download_pdf: 'Tải xuống bảng dữ liệu',
      loading: 'Đang tải...',
      not_found: 'Không tìm thấy sản phẩm',
      load_error: 'Không thể tải chi tiết sản phẩm. Vui lòng thử lại sau.',
      fields: {
        Title: 'Tên sản phẩm',
        Package: 'Gói',
        ProductStatus: 'Trạng thái sản phẩm',
        MOSFETType: 'Loại MOSFET',
        Technology: 'Công nghệ',
        IDA: 'Dòng Drain (A)',
        VDSMin: 'Điện áp Drain-Source (V)',
        RDSon: 'Điện trở bật (mΩ)',
        VGS: 'Điện áp Gate-Source (V)',
        Qg: 'Điện tích cổng tổng (nC)',
        Ciss: 'Điện dung đầu vào (pF)',
        Coss: 'Điện dung đầu ra (pF)',
        Crss: 'Điện dung truyền ngược (pF)',
        FileUrl: 'Bảng dữ liệu'
      }
    },
    table: {
      model: 'Mẫu',
      package: 'Gói',
      product_status: 'Trạng thái sản phẩm',
      mosfet_type: 'Loại MOSFET',
      technology: 'Công nghệ',
      current: 'Dòng điện',
      voltage: 'Điện áp',
      datasheet: 'Bảng dữ liệu',
      view_pdf: 'Xem PDF',
      actions: 'Hành động'
    }
  },
  about: {
    company_intro: 'Giới thiệu công ty',
    company_desc: '765.info chuyên cung cấp các giải pháp bán dẫn công suất hiệu năng cao, độ tin cậy cao. Với công nghệ thiết kế chip tiên tiến và quy trình sản xuất trưởng thành, chúng tôi cung cấp các linh kiện cốt lõi chất lượng như MOSFET, IC quản lý nguồn DC-DC và chip chuyển đổi AC-DC cho tự động hóa công nghiệp, năng lượng mới, nhà thông minh, điện tử tiêu dùng và các lĩnh vực khác, giúp khách hàng nâng cao hiệu suất sản phẩm và giảm chi phí hệ thống.',
    
    core_advantages: 'Lợi thế cốt lõi',
    advantage_direct_supply_title: 'Cung cấp trực tiếp từ nhà máy',
    advantage_direct_supply_desc: 'Hợp tác sâu rộng với các đối tác nhà máy đảm bảo sản phẩm chính hãng với lợi thế giá cả đáng kể.',
    advantage_tech_leadership_title: 'Dẫn đầu về công nghệ',
    advantage_tech_leadership_desc: 'Cung cấp các thiết bị công suất với quy trình tiên tiến như VD-Trench, SJ-MOS và SGT-MOS để đáp ứng yêu cầu hiệu suất cao và tổn thất thấp.',
    advantage_solution_support_title: 'Hỗ trợ giải pháp',
    advantage_solution_support_desc: 'Cung cấp thiết kế tham khảo cho truyền động động cơ, quản lý nguồn, chiếu sáng LED và nhiều lĩnh vực khác để rút ngắn chu kỳ phát triển của khách hàng.',
    advantage_quick_response_title: 'Phản hồi nhanh',
    advantage_quick_response_desc: 'Hàng tồn kho sẵn có và chuỗi cung ứng linh hoạt hỗ trợ cả mẫu lô nhỏ và mua sắm quy mô lớn.',
    
    main_products: 'Sản phẩm chính',
    mosfet_series_title: 'Dòng MOSFET',
    mosfet_low_voltage: 'MOS điện áp trung-thấp (20V-200V): Phù hợp cho công cụ điện và bảo vệ pin lithium.',
    mosfet_high_voltage: 'MOS điện áp cao (500V-650V): Được sử dụng trong nguồn điện công nghiệp và bộ biến tần quang điện.',
    dcdc_chips_title: 'Chip chuyển đổi DC-DC',
    dcdc_chips_desc: 'Dòng (40V/2A), dòng (5V/3A), thay thế các thương hiệu nhập khẩu.',
    acdc_chips_title: 'Chip chuyển đổi AC-DC',
    acdc_chips_desc: 'Các giải pháp hỗ trợ ứng dụng chuyển đổi từ 220V sang 5V/12V cho thiết bị gia dụng, công tơ điện thông minh, v.v.',
    custom_services_title: 'Dịch vụ tùy chỉnh',
    custom_services_desc: 'Cung cấp hỗ trợ kỹ thuật cho việc lựa chọn chip, tối ưu hóa mạch, thiết kế mô-đun và nhiều dịch vụ khác.',
    
    service_areas: 'Lĩnh vực dịch vụ',
    area_industrial_control: 'Điều khiển công nghiệp (Truyền động động cơ, PLC)',
    area_new_energy: 'Năng lượng mới (Lưu trữ năng lượng, Trạm sạc xe điện)',
    area_consumer_electronics: 'Điện tử tiêu dùng (Sạc nhanh, Chiếu sáng LED)',
    area_smart_home: 'Nhà thông minh (Thiết bị gia dụng, Thiết bị an ninh)',
    
    mission_vision: 'Sứ mệnh và Tầm nhìn',
    mission_vision_desc: 'Chúng tôi hướng tới mục tiêu "làm cho các thiết bị công suất hiệu quả dễ tiếp cận" bằng cách kết hợp sức mạnh kỹ thuật chuyên nghiệp với dịch vụ địa phương hóa của chúng tôi để cung cấp các giải pháp bán dẫn ổn định và đổi mới cho khách hàng.'
  },
  contact: {
    info_title: 'Thông tin liên hệ',
    address_title: 'Địa chỉ',
    address_value: 'Phòng 2305, Tòa nhà Jinhao, Số 109 Đường Quảng Thâm (Đoạn Phú Dung), Cộng đồng Phượng Hoàng, Phố Phú Dung, Quận Bảo An, Thâm Quyến, Trung Quốc',
    phone_title: 'Điện thoại',
    phone_value: '+86 139-8626-3349',
    email_title: 'Email',
    hours_title: 'Giờ làm việc',
    hours_value: 'Thứ Hai đến Thứ Sáu, 9:00 - 18:00',
    form_title: 'Mẫu liên hệ',
    name: 'Tên',
    name_placeholder: 'Vui lòng nhập tên của bạn',
    email: 'Email',
    email_placeholder: 'Vui lòng nhập email của bạn',
    subject: 'Chủ đề',
    subject_placeholder: 'Vui lòng nhập chủ đề',
    message: 'Tin nhắn',
    message_placeholder: 'Vui lòng nhập tin nhắn của bạn',
    submit: 'Gửi',
    form_success: 'Tin nhắn của bạn đã được gửi thành công. Chúng tôi sẽ liên hệ với bạn sớm!',
    location: 'Vị trí của chúng tôi',
    map_placeholder: 'Đang tải bản đồ...',
    email_note: 'Sau khi gửi, đội ngũ của chúng tôi sẽ nhận được tin nhắn của bạn',
    errorMessage: 'Gửi email thất bại. Vui lòng thử lại sau.'
  }
}